<script setup>
import {ref, watch} from 'vue';

const props = defineProps({
  numerator: [Number, String],
  denominator: [Number, String],
  label: String
});

const emits = defineEmits(['update:numerator', 'update:denominator']);

const localNumerator = ref(props.numerator);
const localDenominator = ref(props.denominator);

const updateValue = () => {
  if (localNumerator.value < 1) localNumerator.value = 1;
  if (localDenominator.value < 1) localDenominator.value = 1;
  emits('update:numerator', localNumerator.value);
  emits('update:denominator', localDenominator.value);
};

watch(localNumerator, (newValue) => {
  if (newValue >= 1) emits('update:numerator', newValue);
});

watch(localDenominator, (newValue) => {
  if (newValue >= 1) emits('update:denominator', newValue);
});

watch(() => props.numerator, (newValue) => {
  localNumerator.value = newValue;
});

watch(() => props.denominator, (newValue) => {
  localDenominator.value = newValue;
});
</script>

<template>
  <div class="bet-calc-single-fractional-input">
    <label for="odds" class="fractional-label">{{ label }}</label>
    <input type="number" v-model.number="localNumerator" @change="updateValue" class="fractional-input"> /
    <input type="number" v-model.number="localDenominator" @change="updateValue" class="fractional-input">
  </div>
</template>


<style scoped>
.bet-calc-single-fractional-input {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 2rem 0.5rem;
  font-family: Arial, sans-serif;
}

.fractional-label {
  font-size: 0.8rem;
  color: #333;
}

@media (min-width: 576px) {
  .fractional-label {
      font-size: 1rem;

    margin-right: 1.5rem;
    white-space: nowrap;
  }
}

.fractional-input {
  width: 5rem;
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  text-align: center;
  flex: 1;
}

.fractional-input::placeholder {
  color: #aaa;
}

.fractional-input:focus {
  border-color: #128ced;
  outline: none;
}

.fractional-input:invalid {
  border-color: #e74c3c;
}

.fractional-input::-webkit-outer-spin-button,
.fractional-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.fractional-input[type='number'] {
  -moz-appearance: textfield;
}

</style>

